import React from "react";

function Contact() {
  return (
    <section id="contact" className="section contact-us">
      <h2>Contact Us</h2>
      <div className="contact-info">
        <div className="contact-details">
          <p>For bookings or inquiries, reach us at:</p>
          <p>Email: <a href="mailto:irynalaserglow@gmail.com">irynalaserglow@gmail.com</a></p>
          <p>Phone: <a href="tel:+447588556751">+44 7588556751</a></p>
          <p>Address: 102 Snake Lane, IG8 7HX, London, UK</p>
        </div>
      </div>

      <div className="social-media">
        <h3>Follow Us</h3>
        <a href="https://www.instagram.com/iryna_laser_glow/" target="_blank" rel="noopener noreferrer">
          <img src="/image/Instagram.png" alt="Instagram" className="social-icon" />
        </a>
        <a href="https://www.facebook.com/profile.php?id=61567286369269&rdid=SYeYMVynG7gD0zom&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FirefDBEjG6ydCncz%2F" target="_blank" rel="noopener noreferrer">
          <img src="/image/Facebook.jpeg" alt="Facebook" className="social-icon" />
        </a>
      </div>

      <div className="map-container">
        <h3>Find Us Here</h3>
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2477.8303570961157!2d0.03545597664833914!3d51.60799687183642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a0d05ea87d6d%3A0x2ebb369b23bb4074!2s102%20Snake%20Ln%2C%20London%20E11%202QT!5e0!3m2!1sen!2suk!4v1710331234567!5m2!1sen!2suk"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
}

export default Contact;
